"use client";

import { Logomark } from "@/components/logomark";
import { useBreadcrumbs } from "@/hooks/use-breadcrumbs";
import { useWorkspaceNavigation } from "@/hooks/use-workspace-navigation";
import { routes } from "@/lib/navigation/routes";
import { cn } from "cn";
import Link from "next/link";
import { CrumbVariantContext } from "../top-nav/crumb";
import { CrumbForDescriptor, crumbKey } from "../top-nav/index";

/**
 * The head of the rail: the Teral mark, then where you are as a path that
 * reads top to bottom (workspace, project, app). Each level is its own
 * switcher; a hairline connects the levels so nesting reads at a glance.
 */
export function ContextPath() {
  const workspace = useWorkspaceNavigation();
  const crumbs = useBreadcrumbs();

  return (
    <div className="flex flex-col gap-3 px-2 pt-3 pb-1">
      <div className="flex h-8 items-center gap-2.5 px-1 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0">
        <Link
          href={routes.workspaces.overview({ workspaceSlug: workspace.slug })}
          aria-label="Teral"
          className="inline-flex shrink-0 rounded-lg outline-hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--focus-ring)"
        >
          <Logomark />
        </Link>
        <span className="font-display text-[15px] text-gray-12 group-data-[collapsible=icon]:hidden">
          Teral
        </span>
      </div>

      <CrumbVariantContext.Provider value="rail">
        <ol aria-label="Breadcrumb" className="flex flex-col">
          {crumbs.map((descriptor, i) => (
            <li
              key={crumbKey(descriptor)}
              className={cn(
                "relative",
                i > 0 &&
                  "pl-4 before:absolute before:top-0 before:bottom-1/2 before:left-[15px] before:w-2.5 before:rounded-bl-md before:border-b before:border-l before:border-grayA-6 group-data-[collapsible=icon]:pl-0 group-data-[collapsible=icon]:before:hidden",
                i === 0 &&
                  crumbs.length > 1 &&
                  "after:absolute after:top-1/2 after:bottom-0 after:left-[15px] after:border-l after:border-grayA-6 group-data-[collapsible=icon]:after:hidden",
                i > 0 &&
                  i < crumbs.length - 1 &&
                  "after:absolute after:top-0 after:bottom-0 after:left-[15px] after:border-l after:border-grayA-6 group-data-[collapsible=icon]:after:hidden",
              )}
            >
              <CrumbForDescriptor descriptor={descriptor} />
            </li>
          ))}
        </ol>
      </CrumbVariantContext.Provider>
    </div>
  );
}
